import { lc } from '@/i18n/copy';
import type { Language } from '@/i18n/types';

const copy = {
  en: {
    love: 'Send love to someone today',
    gratitude: 'Who deserves to hear this?',
    closure: 'Is there something you need to say?',
    celebration: 'Celebrate someone right now',
  },
  es: {
    love: 'Envía amor a alguien hoy',
    gratitude: '¿Quién merece escuchar esto?',
    closure: '¿Hay algo que necesitas decir?',
    celebration: 'Celebra a alguien ahora mismo',
  },
  fr: {
    love: "Envoyez de l'amour à quelqu'un aujourd'hui",
    gratitude: 'Qui mérite d\'entendre ça ?',
    closure: 'Y a-t-il quelque chose que vous devez dire ?',
    celebration: 'Célébrez quelqu\'un maintenant',
  },
  pt: {
    love: 'Envie amor para alguém hoje',
    gratitude: 'Quem merece ouvir isso?',
    closure: 'Tem algo que você precisa dizer?',
    celebration: 'Celebre alguém agora mesmo',
  },
  ar: {
    love: 'أرسل حباً لشخص ما اليوم',
    gratitude: 'من يستحق أن يسمع هذا؟',
    closure: 'هل هناك شيء تحتاج أن تقوله؟',
    celebration: 'احتفِ بشخص ما الآن',
  },
  ja: {
    love: '今日、誰かに愛を送りましょう',
    gratitude: '誰がこれを聞く価値がありますか？',
    closure: '伝えるべきことはありませんか？',
    celebration: '今すぐ誰かを祝いましょう',
  },
  ko: {
    love: '오늘 누군가에게 사랑을 보내세요',
    gratitude: '누가 이것을 들을 자격이 있나요?',
    closure: '말해야 할 것이 있나요?',
    celebration: '지금 바로 누군가를 축하하세요',
  },
  id: {
    love: 'Kirim cinta ke seseorang hari ini',
    gratitude: 'Siapa yang pantas mendengar ini?',
    closure: 'Apakah ada sesuatu yang perlu Anda sampaikan?',
    celebration: 'Rayakan seseorang sekarang',
  },
  hi: {
    love: 'आज किसी को प्यार भेजें',
    gratitude: 'इसे सुनने का हक किसका है?',
    closure: 'क्या कुछ है जो आपको कहना चाहिए?',
    celebration: 'अभी किसी को सेलिब्रेट करें',
  },
};

export function getNudgeCTA(category: string, language: Language): string {
  const c = lc(copy, language);
  return (c as any)[category] || (c as any).love;
}
